import * as actionTypes from '../constants/actionTypes';
export function setIsUserAuthenticated(isAuthenticated) {
    return {
        type: actionTypes.SET_USER_PROP,
        key: 'isAuthenticated',
        value: isAuthenticated,
    };
}
export function setUserRole(role) {
    return {
        type: actionTypes.SET_USER_PROP,
        key: 'role',
        value: role,
    };
}
export function setUserCompanyId(companyId) {
    return {
        type: actionTypes.SET_USER_PROP,
        key: 'companyId',
        value: companyId,
    };
}
export function setIsSuperUser(isSuperUser) {
    return {
        type: actionTypes.SET_USER_PROP,
        key: 'isSuperUser',
        value: isSuperUser,
    };
}
export function setIsUserInHandoffTestGroup(isInHandoffTestGroup) {
    return {
        type: actionTypes.SET_USER_PROP,
        key: 'isInHandoffTestGroup',
        value: isInHandoffTestGroup,
    };
}
